import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const borderColor = '#AAAAAA';
const specialBorderColor = '#F3F3F4';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#F45B69',
        color: theme.palette.common.white,
        fontWeight: 700,
        border: `1px solid ${borderColor}`,
        verticalAlign: 'baseline',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        border: `1px solid ${borderColor}`,
        color: '#555555',
        verticalAlign: 'baseline',
    },
    '&:first-child': {
        borderLeft: `1px solid ${specialBorderColor}`,
    },
    '&:last-child': {
        borderRight: `1px solid ${specialBorderColor}`,
    },
}));

const BoldTableCell = styled(StyledTableCell)(({ theme }) => ({
    fontWeight: 'bold',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#CCE5E5',
    }
}));

const AnnexureSevenTable = ({
    tableData
}) => {

    return (
        <>
            <TableContainer sx={{ width: "100%" }}>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <BoldTableCell>SDG</BoldTableCell>
                            <BoldTableCell>Goal</BoldTableCell>
                            <BoldTableCell>Targets</BoldTableCell>
                            <BoldTableCell>Relevant Design Considerations</BoldTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            tableData?.map((elem) => (
                                <StyledTableRow>
                                    <StyledTableCell>{elem.data1}</StyledTableCell>
                                    <StyledTableCell>{elem.data2}</StyledTableCell>
                                    <StyledTableCell>{elem.data3}</StyledTableCell>
                                    <StyledTableCell>{elem.data4}</StyledTableCell>
                                </StyledTableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default AnnexureSevenTable;



